import React, { useCallback, useMemo } from 'react'
import block from 'bem-cn'

import { PaymentTypesType } from 'services/api/PaymentApi/types/common'
import { ISystemListItem } from 'services/api/PaymentApi/types/types'

import { ReactComponent as ArrowSvg } from 'shared/img/payment/arrow.svg'

import { LocalePaymentType } from 'shared/locale/en-US'

import { DescriptionBlock } from '../DescriptionBlock/DescriptionBlock'

import './AdditionalPayment.scss'

type IAdditionalPayment = {
  paymentType: PaymentTypesType
  systemItem: ISystemListItem
  locale: LocalePaymentType
  changeSystem: (system: string) => void
}

const b = block('additional-payment')

export const AdditionalPayment: React.FC<IAdditionalPayment> = ({ systemItem, paymentType, locale, changeSystem }) => {
  const paymentKey = useMemo(() => `${paymentType}_${systemItem?.method}`, [paymentType, systemItem?.method])

  const renderComponent = useMemo(() => {
    switch (paymentKey) {
      default:
        return (
          <div className={b('content')}>
            <DescriptionBlock paymentKey={`${paymentType}_${systemItem?.method}`} />
          </div>
        )
    }
  }, [locale, paymentKey, paymentType, systemItem?.method])

  const onCloseCurrentPayment = useCallback(() => {
    changeSystem('')
  }, [changeSystem])

  return (
    <div className={b()}>
      <div className={b('header')}>
        <span className={b('header-arrow')} onClick={onCloseCurrentPayment}>
          <ArrowSvg className={b('header-arrow-icon')} />
        </span>
        <span className={b('header-title')}>{locale[paymentType]}</span>
      </div>
      {renderComponent}
    </div>
  )
}
